import { Provider } from 'react-redux';
import { BrowserRouter, Outlet, Route, Routes, useLocation } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { SessionProvider } from './contexts/SessionContext';
import { store, persistor } from './store';

import { Header } from './components/Header';
import { RequireLogin } from './components/general/RequireLogin';
import { ForgotPassword, Login, ResetPassword } from './components/Login';
import { Main } from './components/Main';
import { CreateForm } from './components/CreateForm';
import { Forms } from './components/Forms';
import { FeedbackForm } from './components/FeedbackForm';
import { ThankYou } from './components/ThankYou';
import { Analytics } from './components/Analytics';
import { FeedbackButton } from './components/FeedbackButton';
import { Footer } from './components/Footer';
import { Modals } from './components/modals';
import { ToastContainer } from 'react-toastify';

import ScrollToTop from './components/general/ScrollToTop';
import SessionExpirationTimer from './components/general/SessionExpirationTimer';

import './App.css';
import 'react-toastify/dist/ReactToastify.css';

const ConditionalLayout = ({ children }) => {
  const location = useLocation();
  const hideLayout =
    location.pathname.match(/^\/forms\/[^/]+/) || location.pathname.includes('/submitted');

  return hideLayout ? null : children;
};

const Router = () => {
  return (
    <BrowserRouter>
      <ConditionalLayout>
        <Header />
      </ConditionalLayout>
      <Routes>
        {/* Public login routes */}
        <Route path="/login" exact={true} element={<Login />} />
        <Route path="/login/forgot-password" element={<ForgotPassword />} />
        <Route path="/login/reset-password/:resetPasswordToken" element={<ResetPassword />} />

        {/* Public form routes */}
        <Route path="/forms/:id" exact={true} element={<FeedbackForm />} />
        <Route path="/forms/:id/submitted" element={<ThankYou />} />

        {/* Login protected routes */}
        <Route
          element={
            <RequireLogin>
              <SessionExpirationTimer />
              <Outlet />
              <FeedbackButton />
            </RequireLogin>
          }
        >
          <Route path="/" exact={true} element={<Main />} />
          <Route path="/create-form" exact={true} element={<CreateForm />} />
          <Route path="/forms" exact={true} element={<Forms />} />
          <Route path="/analytics" exact={true} element={<Analytics />} />
        </Route>
      </Routes>
      <ConditionalLayout>
        <Footer />
      </ConditionalLayout>
      <Modals />
      <ScrollToTop />
      <ToastContainer />
    </BrowserRouter>
  );
};

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <SessionProvider>
        <Router />
      </SessionProvider>
    </PersistGate>
  </Provider>
);

export default App;
